import React from 'react';
import { Link } from 'react-router-dom';

import NumberColor from '../../../Components/NumberColor';
import FITTypeHelper from '../Helpers/FITTypeHelper';

import FitItemPricing from './FitItemPricing';
import AppConfig from '../../../AppConfig';
import TravelerHelper from '../../../Helper/Traveler';

export default class FITItemVisa extends React.Component {
	getTravelersBySelectedFitType = item => {
		if (!item) return [];
		const fitKey = item.selectedFitType && item.selectedFitType.value ? item.selectedFitType.value : item.fitType;
		// travelers are stored under the selected fit type key, e.g. item.fitVisa.travelers
		if (fitKey && item[fitKey] && Array.isArray(item[fitKey].travelers)) {
			return item[fitKey].travelers;
		}
		// Backward compatible fallback (if backend returns `item.travelers`)
		return Array.isArray(item.travelers) ? item.travelers : [];
	};

	getTravelerId = traveler => {
		if (!traveler) return null;
		if (traveler.id != null) return traveler.id;
		return null;
	};

	getTravelerDisplayName = traveler => {
		if (!traveler) return '-';
		return TravelerHelper.getFullName(traveler);
	};

	renderTravelers = item => {
		const travelers = this.getTravelersBySelectedFitType(item);
		if (travelers.length === 0) return null;
		return (
			<div>
				<h4 className="title is-4">Travelers</h4>
				{travelers.length > 0 ? (
					<div className="columns is-multiline" style={{ marginTop: 6 }}>
						{travelers.map((traveler, idx) => {
							const name = this.getTravelerDisplayName(traveler);
							const travelerId = this.getTravelerId(traveler);
							const content = `${idx + 1}. ${name}`;
							const travelerTextStyle = {
								display: 'block',
								...TravelerHelper.fullNameStyle,
								overflowWrap: 'anywhere',
								wordBreak: 'break-word',
							};
							return (
								<div
									className="column is-3"
									key={'traveler-' + (travelerId != null ? travelerId : idx)}
									style={{ paddingTop: 6, paddingBottom: 6 }}
								>
									{travelerId != null ? (
										<Link to={AppConfig.appPath + '/travelers/' + travelerId} style={travelerTextStyle}>
											{content}
										</Link>
									) : (
										<span style={travelerTextStyle}>{content}</span>
									)}
								</div>
							);
						})}
					</div>
				) : null}
			</div>
		);
	};

	render() {
		const { item, fitItemHelper } = this.props;
		// console.log('item: ', item);
		const type = FITTypeHelper.mapLabel(item.fitType);
		const fitDetail = item[item.fitType] && item[item.fitType].details ? item[item.fitType].details : [];
		const pricing = fitItemHelper.getItemPrice(item);
		return (
			<div className="box" key={'item' + item.id}>
				<div className="columns">
					<div className="column is-6">
						<h4 className="title is-4">{type}</h4>
					</div>
					<div className="column is-6">
						<FitItemPricing
							pricing={pricing}
							creditCard={item.creditCard}
							creditCardRecord={item.creditCardRecord}
							creditCardCurrency={item.creditCardCurrency}
						/>
					</div>
				</div>
				<table className="table is-fullwidth is-bordered is-hoverable">
					<thead>
						<tr className="table-header-green">
							<td width="40%">รายการ</td>
							<td>ราคาขาย</td>
							<td>ต้นทุน</td>
						</tr>
					</thead>
					<tbody>
						{fitDetail &&
							fitDetail.map(detail => (
								<tr key={'detail' + item.fitType + detail.id}>
									<td>{detail.title}</td>
									<td style={{ textAlign: 'right' }}>
										<NumberColor number={detail.salePrice} />
									</td>
									<td style={{ textAlign: 'right' }}>
										<NumberColor number={detail.price} isExpense={true} />
									</td>
								</tr>
							))}
						<tr className="table-summary-row">
							<td />
							<td style={{ textAlign: 'right' }}>
								<NumberColor number={pricing.salePrice} />
							</td>
							<td style={{ textAlign: 'right' }}>
								<NumberColor number={pricing.price} isExpense={true} />
							</td>
						</tr>
					</tbody>
				</table>
				{this.renderTravelers(item)}
			</div>
		);
	}
}
